import { Component,ViewChildren,ElementRef,QueryList } from '@angular/core';
import { ModalController, NavParams, ViewController,AlertController } from 'ionic-angular';
import { AppState } from '../../../../app/app.global';
import { Utils } from '../../../../providers/service/utils';
@Component({
  selector: 'freeclassroom-page',
  templateUrl: 'freeclassroom.html'
})

export class FreeClassroom {
	session:any = [1,2,3,4,5,6,7,8,9,10];
	freeinfo:any = [];
	@ViewChildren('freeClassroomRow')
  freeClassroomRows: QueryList<ElementRef>;
  myDate;
	constructor(public global: AppState,public modalCtrl: ModalController) {}
	ngOnInit(){
		this.freeinfo = [
       {"name":'实验一楼301',"freeClass":[1,2,3,6]},
       {"name":'实验一楼306',"freeClass":[2,4,6,7,8]},
       {"name":'实验一楼308',"freeClass":[2,3,6,7,8]},
       {"name":'实验一楼301',"freeClass":[1,2,3,6]},
       {"name":'实验一楼306',"freeClass":[2,4,5,7,8]},
       {"name":'实验一楼308',"freeClass":[2,3,6,7,8]},
       {"name":'实验一楼301',"freeClass":[1,2,3,6]},
       {"name":'实验一楼306',"freeClass":[2,4,5,7,8]},
       {"name":'实验一楼308',"freeClass":[2,3,6,7,8]},
       {"name":'实验一楼301',"freeClass":[1,2,3,6]},
       {"name":'实验一楼306',"freeClass":[2,4,6,7,8]},
       {"name":'实验一楼308',"freeClass":[2,3,6,7,8]}
     ];
     this.myDate = Utils.dateFormat(new Date(),'yyyy-MM-dd');
	}
	ngAfterViewInit(){
		this.setColColor();
	}
	setColColor(){
		if(this.freeinfo!=undefined&&this.freeinfo.length!==0){
			for(let i =0 ; i < this.freeinfo.length;i++){
     	  let ionRow = this.freeClassroomRows["_results"][i].nativeElement;
     	  let cols = ionRow.getElementsByTagName('ion-col');
     	  for(let k = 0; k < cols.length; k++){
     	  	cols[k].style.backgroundColor = '';
     	  }
     	  for(let j=0;j<this.freeinfo[i].freeClass.length;j++){
     	  	let index = this.freeinfo[i].freeClass[j];
     	  	cols[index].style.backgroundColor = "#58c583"
     	  }
     }
		}
	}
	
	preDate(){
		let d = new Date(this.myDate);
		this.myDate = Utils.dateFormat(new Date(d.getTime() -  24*60*60*1000) ,'yyyy-MM-dd');
	}
	
	nextDate(){
		let d = new Date(this.myDate);
		this.myDate = Utils.dateFormat(new Date(d.getTime() + 24*60*60*1000) ,'yyyy-MM-dd');
	}
	
  changeDate($event){
  	console.log("时间改变触发"+$event);
  	this.getFreeClassroomData();
  }
  
  presentModal(){
  	let modal = this.modalCtrl.create(ModalContentPage);
  	modal.onDidDismiss(data => {
       console.log("选择的数据"+data);
       this.getFreeClassroomData();
    });
    modal.present();
  }
  
  getFreeClassroomData(){
  	console.log("获取空闲教室的数据");
  }
}

@Component({
	template:`
	<ion-header>
  <ion-toolbar>
    <ion-title>
      搜索
    </ion-title>
    <ion-buttons start>
      <button ion-button (click)="dismiss()">
        <span ion-text color="primary" showWhen="ios">取消</span>
        <ion-icon name="md-close" showWhen="android, windows"></ion-icon>
      </button>
    </ion-buttons>
    <ion-buttons end>
      <button ion-button (click)="confirm()">
        <span ion-text color="primary" showWhen="ios">确定</span>
        <ion-icon name="md-close" showWhen="android, windows"></ion-icon>
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
 <ion-content>
	<ion-list>
  <ion-item>
    <ion-label>校区</ion-label>
    <ion-select [(ngModel)]="campus" cancelText="取消" okText="确定" interface="action-sheet">
      <ion-option *ngFor="let item of campusList" value={{item.code}}>{{item.name}}</ion-option>
    </ion-select>
  </ion-item>
  <ion-item>
    <ion-label>教学楼</ion-label>
    <ion-select [(ngModel)]="teachingBuilding"  cancelText="取消" okText="确定" >
        <ion-option *ngFor="let item of classRoomList"  value={{item.code}}>{{item.name}}</ion-option>
    </ion-select>
  </ion-item>
  </ion-list>
  </ion-content>
	`
})

export class ModalContentPage{
	  campus;
	  teachingBuilding;
	  campusList:any=[];
	  classRoomList:any=[];
	  constructor(public params: NavParams,public viewCtrl: ViewController,public alertCtrl: AlertController){
	  	this.campusList = [
	  	  {'code':'ca','name':'长安校区'},
	  	  {'code':'yt','name':'雁塔校区'}
	  	];
	  	this.classRoomList = [
	  	  {'code':'0','name':'教室一'},
	  	  {'code':'1','name':'教室二'},
	  	  {'code':'2','name':'教室三'},
	  	  {'code':'3','name':'教室四'}
	  	];
	  	this.campus = this.campusList[0].code;
	  	this.teachingBuilding = this.classRoomList[0].code;
	  }
	  dismiss() {
      this.viewCtrl.dismiss();
    }
	  confirm(){
	  	let param = {"campus":this.campus,"teachingBuilding":this.teachingBuilding };
	  	this.viewCtrl.dismiss(param);
	  }
}



// WEBPACK FOOTER //
// ./src/pages/application/teaching/freeclassroom/freeclassroom.ts